import { AxiosRequestConfig } from "axios";
import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateReferenceModel } from "../../models/references/CreateReferenceModel";
import { UpdateReferenceModel } from "../../models/references/UpdateReferenceModel";

const RESOURCE_NAME = "tablemapping";

const getAllReferences = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getAllReferences`, requestConfig());
};

const getReferenceValidationTypes = () =>{
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getReferenceValidationTypes`, requestConfig());
}

const downloadReferences = (model: any) => {
  const http = getAxiosInstance();
  let config: AxiosRequestConfig = requestConfig();
  config.responseType = "blob";

  return http.get(
    `${RESOURCE_NAME}/downloadReferences?validationType=${model.validationType}`,
    config
  );
};

const uploadReferences = (model: any) => {
  const http = getAxiosInstance();
  const formData = new FormData();
  formData.append("file", model.file);
  formData.append("validationType", model.validationType);

  return http.post(
    `${RESOURCE_NAME}/uploadReferences`,
    formData,
    requestConfig()
  );
};

const createReference = (model: CreateReferenceModel) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/createReference`, model, requestConfig());
};

const updateReference = (model: UpdateReferenceModel) => {
  const http = getAxiosInstance();
  return http.put(
    `${RESOURCE_NAME}/updateReference/${model.id}`,
    model,
    requestConfig()
  );
};

const deleteRefereence = (referenceId: number) => {
  const http = getAxiosInstance();
  return http.delete(
    `${RESOURCE_NAME}/deleteReference/${referenceId}`,
    requestConfig()
  );
};

const deleteRefereences = (validationType: string) => {
  const http = getAxiosInstance();
  return http.delete(
    `${RESOURCE_NAME}/deleteReferences?validationType=${validationType}`,
    requestConfig()
  );
};

const ReferenceService = {
  getAllReferences,
  getReferenceValidationTypes,
  downloadReferences,
  uploadReferences,
  createReference,
  updateReference,
  deleteRefereence,
  deleteRefereences,
};
export default ReferenceService;
